"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keywords = void 0;
// Reserved keywords not allowed to use in the parser
var keywords = {
  end: true
};
exports.keywords = keywords;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/keywords.js
// module id = dwL+
// module chunks = 23